<div class="wrapper">

  <main-app-header></main-app-header>
  <app-breadcrumbs></app-breadcrumbs>
  <!--<app-header [headerTitle]="'Subscription'"></app-header>-->

  <div class="payment-history-page2">
    <!-- <div class="payment-header">
      <div class="payment-logo">
        <img src="./assets/images/logo.png" />
        <h3>Account Settings</h3>
      </div>
    </div> -->
    <!-- <div class="backlink pointer"><a (click)="backClicked()"><i class="fas fa-chevron-left"></i> Back</a></div> -->
    <!--<div class="logoutlink pointer"><a (click)="logOut()"><i class="fas fa-chevron-right"></i> Logout</a></div>-->
    <div class="payment-history box-shadow" *ngIf="apiCalled">
      <div class="subscription-amount-block">
        <div class="amount" *ngIf="!isFreeUser">
          <!-- <p>Purchased on {{subscriptionDetails?.start_billing_date | date : 'longDate'}}</p> -->
          <!--<span>$</span> <strong>{{amount}}</strong><br />
  <span class="amount-label">Per Month.</span>-->
          <!--<div *ngIf="isActive"><p class="dashText">Subscription status: <font color="#058c03">Active</font></p></div>-->
          <div *ngIf="!isActive">
            <p class="dashText">
              Subscription status: <font color="#9e0202">Inactive</font>
            </p>
          </div>
          <!-- Show Resend Confirmation button ONLY if inactive AND has confirmation token -->
          <div *ngIf="!isActive && confirmationToken" class="buttonPadding">
            <button id="resendConfirmationBtn" (click)="resendCurrentUserConfirmation()" class="btn btn-blue submitBtn">
              Resend Confirmation Email
            </button>
          </div>

          <!-- Show Renew Subscription button ONLY if inactive AND no confirmation token -->
          <div *ngIf="!isActive && !confirmationToken" class="buttonPadding">
            <a id="dashButton" [routerLink]="[ '/subscription-renew' ]" routerLinkActive="active"
              class="btn btn-blue submitBtn">Renew Subscription</a>
          </div>
          <div *ngIf="isActive" class="buttonPadding">
            <a id="dashButton" [routerLink]="[ '/change-password' ]" routerLinkActive="active"
              class="btn btn-blue submitBtn">Change Password</a>
          </div>
          <div *ngIf="isActive" class="buttonPadding">
            <a id="dashButton" [routerLink]="[ '/change-phonenumber' ]" routerLinkActive="active"
              class="btn btn-blue submitBtn">Change Phone Number</a>
          </div>
          <div *ngIf="isActive" class="buttonPadding">
            <a id="dashButton" [routerLink]="[ '/change-email' ]" routerLinkActive="active"
              class="btn btn-blue submitBtn">Change Email</a>
          </div>
          <div *ngIf="isActive" class="buttonPadding">
            <a id="dashButton" [routerLink]="[ '/manage-plans' ]" routerLinkActive="active"
              class="btn btn-blue submitBtn">Manage Subscription</a>
          </div>
          <!-- <div *ngIf="isActive" class="buttonPadding"><a (click)="logOut()" id="dashButton" [routerLink]="[ '/' ]"
      routerLinkActive="active" class="btn btn-blue submitBtn">Logout</a></div> -->
          <div *ngIf="showExpiredCardMessage">
            <p class="dashText">
              <font color="#9e0202">Your credit card has expired. Please update using the change payment option. </font>
            </p>
          </div>
          <div *ngIf="showTerminatedSubMessage">
            <p class="dashText">
              <font color="#9e0202">
                The suspended subscription has been terminated. Please resubscribe using the renew
                subscription option.
              </font>
            </p>
          </div>

        </div>
        <div class="amount" *ngIf="isFreeUser">
          <p></p>
          <!-- <span></span> <strong> Free Plan</strong><br /> -->
          <span class="amount-label"></span>
          <!--<div *ngIf="isActive"><p class="dashText">Subscription status: <font color="#058c03">Active</font></p></div>-->
          <div *ngIf="!isActive">
            <p class="dashText">Subscription status: <font color="#9e0202">Inactive</font>
            </p>
          </div>
          <div *ngIf="isActive" class="buttonPadding"><a id="dashButton" [routerLink]="[ '/change-password' ]"
              routerLinkActive="active" class="btn btn-blue submitBtn">Change Password</a></div>
          <div *ngIf="isActive" class="buttonPadding"><a id="dashButton" [routerLink]="[ '/change-phonenumber' ]"
              routerLinkActive="active" class="btn btn-blue submitBtn">Change Phone Number</a></div>
          <div *ngIf="isActive" class="buttonPadding"><a id="dashButton" [routerLink]="[ '/change-email' ]"
              routerLinkActive="active" class="btn btn-blue submitBtn">Change Email</a></div>
          <div *ngIf="isActive" class="buttonPadding"><a id="dashButton" [routerLink]="[ '/manage-plans' ]"
              routerLinkActive="active" class="btn btn-blue submitBtn">Manage Subscription</a></div>
          <div *ngIf="isActive" class="buttonPadding"><a (click)="logOut()" id="dashButton" [routerLink]="[ '/' ]"
              routerLinkActive="active" class="btn btn-blue submitBtn">Logout</a></div>
        </div>
      </div>

    </div>
  </div>
  <div *ngIf="totalSeatsGET > 0 && startSection && isActive" class="thankyou-box privacy-policy-box">
    <div class="map-form">
      <div>
        <div class="table_padding">
          <button style="font-size: 1.5rem !important;" type="button"
            class="btn btn-orange submitBtn mobile-btn add-user-btn" (click)="openModal()"
            [disabled]="isSubmitBtnDisabled" aria-label="Add user" title="Add user">
            <i class="fa-solid fa-user-plus"></i>
          </button>

          <!--<div *ngIf="paginatedData.length >= totalSeatsGET" class="toolbar-plan-text" style="font-size:14px">
              Seats are full! To add more users
              please free up seats from current users.
            </div>-->
          <div style="display: flex; justify-content: flex-start; align-items: center;">
            <input type="text" id="searchInput" onkeyup="searchFunction()" placeholder="Search..">
            <div style="margin-left: 20px;font-size: 14px; display:grid; text-align:left" class="toolbar-plan-text">
              <strong>Active: {{active_user_counter}}</strong>
              <strong>Inactive: {{inActiveUsers}}</strong>
              <strong [ngStyle]="{'color': isSeatsFull ? 'red' : 'white'}">Total seats assigned: {{seatsTakenCount}} /
                {{totalSeatsGET}}</strong>
            </div>
            <!--<div class="toolbar-plan-text"><strong>Inactive: {{inActiveUsers}}</strong></div>
                <div class="toolbar-plan-text"><strong>Total seats assigned: {{seatsTakenCount}} / {{totalSeatsGET}}</strong></div>-->
          </div>

          <table id="myTable" class="responsive-table mat-elevation-z8">
            <thead style="border:1px solid #fff">
              <tr id="headerTable" class="table-head-lable">
                <th [ngClass]="{
        headerSortDown: currentSortColumn === 'date_added' && currentSortDirection === 'desc',
        headerSortUp: currentSortColumn === 'date_added' && currentSortDirection === 'asc'
      }" (click)="sortBy('date_added')" style="cursor:pointer" scope="col">
                  Date added
                </th>

                <th [ngClass]="{
        headerSortDown: currentSortColumn === 'date_expire' && currentSortDirection === 'desc',
        headerSortUp: currentSortColumn === 'date_expire' && currentSortDirection === 'asc'
      }" (click)="sortBy('date_expire')" style="cursor:pointer" scope="col">
                  Exp Date
                </th>

                <th [ngClass]="{
        headerSortDown: currentSortColumn === 'first_name' && currentSortDirection === 'desc',
        headerSortUp: currentSortColumn === 'first_name' && currentSortDirection === 'asc'
      }" (click)="sortBy('first_name')" style="cursor:pointer" scope="col">
                  First Name
                </th>

                <th [ngClass]="{
        headerSortDown: currentSortColumn === 'last_name' && currentSortDirection === 'desc',
        headerSortUp: currentSortColumn === 'last_name' && currentSortDirection === 'asc'
      }" (click)="sortBy('last_name')" style="cursor:pointer" scope="col">
                  Last Name
                </th>

                <th [ngClass]="{
        headerSortDown: currentSortColumn === 'email_id' && currentSortDirection === 'desc',
        headerSortUp: currentSortColumn === 'email_id' && currentSortDirection === 'asc'
      }" (click)="sortBy('email_id')" style="cursor:pointer" scope="col">
                  Email
                </th>


                <th scope="col">Phone Number</th>
                <th scope="col">Role</th>
                <th scope="col">
                  Active
                  <button class="dropdown-btn" (click)="toggleDropdown()">
                    <i class="headerSortDownActive" style=""></i>
                  </button>
                  <div>
                    <div *ngIf="dropdownVisible" class="dropdown-content" id="activeFilter">
                      <ul style="padding-left: 0rem !important;">
                        <li class="dropdown-options-ui btn btn-orange submitBtn" (click)="selectOption('all')">All</li>
                        <li class="dropdown-options-ui btn btn-orange submitBtn" (click)="selectOption('active')">Active
                        </li>
                        <li class="dropdown-options-ui btn btn-orange submitBtn" (click)="selectOption('inactive')">
                          Inactive</li>
                      </ul>
                    </div>

                    <!--<select *ngIf="dropdownVisible" class="dropdown-content" id="activeFilter" [(ngModel)]="selectedActiveStatus" (change)="filterTable()">
        <option value="all">All</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>-->
                  </div>
                </th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of paginatedData">
                <td data-title="Date added">{{user.date_added | date: 'shortDate' }}</td>
                <td *ngIf="user.date_expire != null else elseBlock" data-title="Exp date">
                  {{
                  user.date_expire | date:
                  'shortDate'
                  }}
                </td>
                <ng-template #elseBlock>
                  <td data-title="Exp Date">Ongoing</td>
                </ng-template>
                <td data-title="First Name">{{user.first_name}}</td>
                <td data-title="Last Name">{{user.last_name}}</td>
                <td data-title="Email">{{user.email_id}}</td>
                <td data-title="Phone Number">{{user.phone_number.internationalNumber}}</td>
                <td data-title="Role">{{ user.role }}</td>
                <td [ngClass]="{'active-yes': user.is_active, 'active-no': !user.is_active}" data-title="Is Active">
                  {{ user.is_active ? 'YES' : 'NO' }}
                </td>
                <td>
                  <!--<button class="btn btn-orange submitBtn mobile-btn tablet-width" (click)="onEdit(user)">Edit</button></td>-->
                  <button *ngIf="canManageUsers()" title="Edit" class="btn btn-orange submitBtn mobile-btn tablet-width"
                    (click)="onEdit(user)"><i class="fa-solid fa-pencil"></i></button>
                <td>
                  <!--<button class="btn btn-orange submitBtn mobile-btn tablet-width" (click)="confirmDelete(user)">Delete</button>-->
                  <button *ngIf="canManageUsers()" title="Delete"
                    class="btn btn-orange submitBtn mobile-btn tablet-width" (click)="confirmDelete(user)"><i
                      class="fa fa-trash"></i></button>
                </td>
                <td>
                  <!-- For inactive users: Show dropdown with options -->
                  <div *ngIf="!user.is_active && canManageUsers()" class="resend-dropdown-container">
                    <button title="Resend Invite" class="btn btn-orange submitBtn mobile-btn tablet-width"
                      (click)="sendDirectEmail(user)">
                      <!--(click)="toggleResendDropdown(user.id || user.date_added, $event)">-->
                      <i class="fa-solid fa-envelope"></i>
                    </button>

                    <div *ngIf="resendDropdownVisible[user.id || user.date_added]" class="resend-dropdown-menu">
                      <ul style="padding-left: 0rem !important; margin: 0;">
                        <li class="resend-dropdown-option" (click)="sendDirectEmail(user)">
                          <i class="fa-solid fa-paper-plane"></i> Send directly
                        </li>
                        <li class="resend-dropdown-option" (click)="sendPersonalEmail(user)">
                          <i class="fa-solid fa-user"></i> Send personally
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- For active users: Password reset -->
                  <button *ngIf="user.is_active && canManageUsers()" style="padding-right: 9px;" title="Reset Password"
                    class="btn btn-orange submitBtn mobile-btn tablet-width" (click)="resendUserInformation(user)">
                    <i class="fa-solid fa-user-shield"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div style="display: none;" class="pagination">
            <div class="pagination-left">
              <div class="pagination-counter">Size:</div>
              <select class="form-select" [(ngModel)]="itemsPerPage" (change)="changePageSize($event)">
                <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
              </select>
            </div>
            <div class="pagination-right">
              <div class="pagination-counter">Page: {{ currentPage }}/{{ totalPages }}</div>
              <button class="btn btn-lg btn-outline-primary" (click)="previousPage()" [disabled]="currentPage === 1">
                Previous
              </button>
              <button class="btn btn-lg btn-outline-primary" (click)="nextPage()"
                [disabled]="currentPage === totalPages">
                Next
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- <div *ngIf="addUserPop" class="modal-backdrop" (click)="closeModal()"></div> -->
    <div *ngIf="addUserPop" class="modal" (click)="$event.stopPropagation()">
      <div class="addFormBackground" data-backdrop="static" data-keyboard="false">
        <button (click)="closeModal()" class="close-button">X</button>
        <h3 class="topText" style="color:red">Please enter user details.</h3>
        <div class="form-group plan-box-shadow">
          <div id="emailOrPhoneCheck">
            <form autocomplete="on" [formGroup]="userForm" id="signup-form">
              <ul style="padding-left: 0px !important">
                <li>
                  <input [ngClass]="(signSubmit && f['first_name']?.errors?.required ? 'form-error' : '')" type="text"
                    formControlName="first_name" name="first_name" placeholder="First Name*" />
                </li>
                <li>
                  <input [ngClass]="(signSubmit && f['last_name']?.errors?.required ? 'form-error' : '')" type="text"
                    formControlName="last_name" name="last_name" placeholder="Last Name*" />
                </li>
                <li class="country-dropdown">
                  <ngx-intl-tel-input
                    [ngClass]="(signSubmit && f['phone_number']?.errors?.validatePhoneNumber ? 'form-error' : '')"
                    [cssClass]="'custom'" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true" [customPlaceholder]="'Phone Number*'" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.UnitedStates" [maxLength]="15"
                    [phoneValidation]="true" [separateDialCode]="separateDialCode"
                    [numberFormat]="PhoneNumberFormat.International" name="phone" formControlName="phone_number">
                  </ngx-intl-tel-input>
                </li>
                <li *ngIf="f.phone_number.touched && f.phone_number.invalid">
                  <div *ngIf="f.phone_number.hasError('required') || f.phone_number.hasError('validatePhoneNumber')">
                    <div class="text-danger">
                      Invalid Phone Number!
                    </div>
                  </div>
                </li>
                <li id="showEmail">
                  <input
                    [ngClass]="(signSubmit && f['email_id']?.errors?.required || signSubmit && f['email_id']?.errors?.email ? 'form-error' : '')"
                    type="email" formControlName="email_id" name="email_id" placeholder="Email Address*" email />
                </li>
                <li>
                  <div class="role-select-container">
                    <select formControlName="role" class="form-control role-select"
                      [disabled]="logged_user_role === 'Manager'">
                      <ng-container *ngFor="let r of roles">
                        <!-- never show the Owner option in sub-user dropdown -->
                        <option *ngIf="r !== 'Owner'" [value]="r">
                          {{ r | titlecase }}
                        </option>
                      </ng-container>
                    </select>
                    <div class="role-info-icon-inline">
                      <i class="fas fa-info-circle"></i>
                      <div class="role-tooltip-inline">
                        <strong>Role Information:</strong><br>
                        <span class="role-type">• Members:</span> are part of your group.<br>
                        <span class="role-type">• Managers:</span> can add and delete users which are part of your
                        group.
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <input type="number" formControlName="expiry_date_days" name="expiry_date_days" max="90"
                    placeholder="Days to expire" />
                </li>
                <li *ngIf="f.expiry_date_days.touched || f.expiry_date_days.invalid">
                  <div *ngIf="errorExpDays">
                    <div class="text-danger">
                      {{errorExpDays}}
                    </div>
                  </div>
                </li>
                <li *ngIf="error" class="show__alert__message" style="padding-bottom: 5px;">
                  <div class="alert alert-danger">
                    {{error}}
                  </div>
                </li>
                <li *ngIf="!editUser" class="login-form">
                  <input type="submit" autocomplete="off" [disabled]="isSubmitBtnDisabled || !userForm.valid"
                    (click)="verifyUserSubscription()" class="btn btn-orange submitBtn" name="submit" value="Confirm" />
                </li>
                <li *ngIf="editUser" class="login-form">
                  <input type="submit" autocomplete="off" [disabled]="isSubmitBtnDisabled || !userForm.valid"
                    (click)="confirmUserEdit()" class="btn btn-orange submitBtn" name="submit" value="Confirm" />
                </li>
              </ul>
            </form>
            <form [formGroup]="userForm">
              <div ngModelGroup="userData"></div>
            </form>
            <hr>
            <span style="font-size:11px; color:white;">
              *Days to expire refers to after how many days the created temporary users will expire, the field is not
              required.
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="deleteUserPop" class="modal-delete" (click)="cancelDelete()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <button (click)="cancelDelete()" class="close-button">X</button>
      <h3 class="topText" style="color:red !important">Are you sure you want to delete this user?</h3>
      <div class="modal-footer">
        <button (click)="onDelete()" class="btn btn-danger btn">Yes</button>
        <button (click)="cancelDelete()" class="btn btn-secondary btn">Cancel</button>
      </div>
    </div>
  </div>
</div>
